import { render, staticRenderFns } from "./AbkSurveyStatsBoxInfo.vue?vue&type=template&id=7c5eace8&scoped=true&"
import script from "./AbkSurveyStatsBoxInfo.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyStatsBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyStatsBoxInfo.vue?vue&type=style&index=0&id=7c5eace8&scoped=true&lang=scss&"
import style1 from "./AbkSurveyStatsBoxInfo.vue?vue&type=style&index=1&id=7c5eace8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5eace8",
  null
  
)

export default component.exports